
import "./dashboardCustomersList.css";
import CustomerCard from './CustomerCard';
import { useContext } from "react";
import { AppContext } from "../../../contextApi/ContextApi";

export default function DashbaordCustomers({website}) {
    const {primary_color, secondary_color, accent_color} = useContext(AppContext);
    const deployList=()=>{
        try{
            const clients = website?.settings?.clients;
            if(clients.length > 0){
                return clients.map((client, inx)=>{
                    return <CustomerCard key={`customerCard_${client.name}_${inx}`} website={website} client={client} inx={inx}/>
                })
            }
            else{
                return <h1 style={{color:accent_color, textShadow:`2px 2px 4px ${primary_color}`}}>לא נמצאו לקוחות רשומים</h1>
            }
        } catch(err){console.error("can't deploy list: ",err)}
    }
  return (
    <div>
        <h1 dir='rtl' style={{color:primary_color, textShadow:`2px 2px 4px ${secondary_color}`}}>הלקוחות שלי</h1>
        <div className="clientsList">
            {deployList()}
        </div>
    </div>
  )
}
